export default {
  admin_list: [],
  active_admin: {}
}
